export default "__VITE_ASSET__DxUF6F4O__"